import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useCommentsModalState() {
  return useAppState();
}

export function useCommentsModalActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((state) => ({
      ...state,
      commentsModal: {
        loading: true,
        commentData: [],
        commentDataLoaded: false,
      },
    }));
  }

  function onResponse(response) {
    if (response.feedbackVariant === 'success') {
      dispatch((state) => ({
        ...state,
        commentsModal: {
          ...state.commentsModal,
          commentData: response.comments || [],
          commentDataLoaded: true,
          loading: false,
        },
        feedbackMessage: response.feedbackMessage || null,
        feedbackVariant: response.feedbackVariant || null,
      }));
    } else {
      dispatch((state) => ({
        ...state,
        commentsModal: {
          ...state.commentsModal,
          loading: false,
        },
        feedbackMessage: response.feedbackMessage || null,
        feedbackVariant: response.feedbackVariant || null,
      }));
    }
  }

  function onError(feedback) {
    dispatch((state) => ({
      ...state,
      commentsModal: {
        ...state.commentsModal,
        loading: false,
      },
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  function setCommentDataLoaded(loaded) {
    dispatch((state) => ({
      ...state,
      commentsModal: {
        ...state.commentsModal,
        commentDataLoaded: loaded,
      },
    }));
  }

  function clearFeedback() {
    dispatch((state) => ({
      ...state,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    setCommentDataLoaded,
    clearFeedback,
  };
}
